(function () {
    'use strict';

    angular
        .module('riskModule')
        .directive('grcRiskHistory', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        return {
            scope: boxTmplScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller', 'grcGovernanceProcessService', function ($scope, $controller, grcGovernanceProcessService) {

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/risk/grcRiskHistory.[Template].tpl.html';
                $controller('BoxTmplController', { $scope: $scope });

                // Custom Information
                grcGovernanceProcessService
                    .getActiveRiskSelfAssessments()
                    .then(function (governanceProcess) {
                        $scope.governanceProcess = governanceProcess;
                    });

                // Custom Behavior
                $scope.beforeDifferenceValues = {};

                $scope.getDifferenceValue = function (versioningRisk, differenceName) {
                    var value = versioningRisk[differenceName];

                    if (value === true) value = "Yes";
                    else if (value === false) value = "No";

                    return value;
                }

                $scope.getBeforeDiffenceValue = function (versioningRisk, differenceName) {
                    var beforeDifferenceName = "Before" + differenceName;

                    var beforeValue = $scope.getDifferenceValue(versioningRisk, beforeDifferenceName);
                    return beforeValue;
                }

                $scope.withSameValuesForInitialAndFinalAssessment = function (assessment) {
                    if (assessment.InitialProbabilityCode !== assessment.FinalProbabilityCode) return false;
                    if (assessment.InitialSeverityCode !== assessment.FinalSeverityCode) return false;
                    if (assessment.InitialMitigationCode !== assessment.FinalMitigationCode) return false;
                    if (assessment.InitialOverallCode !== assessment.FinalOverallCode) return false;

                    return true;
                }

                $scope.showRiskAssessment = function (historicRecord) {
                    if (!historicRecord.IsRiskAssessment) { return false; }

                    if ($scope.boxModel.Risk.IsClosed &&
                            historicRecord.RiskAssessment.GovernanceProcess.GovernanceProcessID ===
                            $scope.governanceProcess.ItemID) {
                        return false;
                    }

                    return true;
                };

                // Last Changes
                $scope.getLastChangesOnRisk = function () {
                    if (!_.isUndefined($scope.boxModel) && $scope.boxModel.length > 0) {
                        return $scope.boxModel[0].Timestamp;
                    }
                }

                // Last Assessment
                $scope.getLastAssessment = function () {
                    var lastAssessment = _.find($scope.boxModel, function (record) {
                        return record.IsRiskAssessment;
                    });

                    return lastAssessment;
                }              
            }],

            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();